/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  profile: 'Profil',
  settings: 'Inställningar',
  name: 'Namn',
  email: 'E-post',
  password: 'Lösenord',
  passwordConfirmation: 'Upprepa lösenord',
  locale: 'Språk',
  view: 'Visa',
  comfortable: 'Bekväm',
  compact: 'Kompakt',
  line: 'Linje',
  full: 'Fullständig',
  narrow: 'Smal',
  sort: 'Sortera',
  lastModifiedFirst: 'Senast ändrad först',
  lastCreatedFirst: 'Senast skapad först',
  alphabetically: 'Alfabetisk ordning',
  theme: 'Tema',
  dark: 'Mörkt',
  light: 'Ljust',
  save: 'Spara',
  saveSuccess: 'Profilen har sparats.',
  saveFailure: 'Profilen kunde inte sparas.',
  fetchFailure: 'Profilen kunde inte hämtas.',
  application: 'Applikation',
  install: 'Installera',
  youCanInstallPlainpad: 'Du kan installera Plainpad och använda det direkt från värddatorn.',
  invalidateCache: 'Rensa cache',
  encrypt: 'Kryptera',
  yes: 'Ja',
  no: 'Nej',
  passwordsMismatch: 'Lösenorden matchar inte, vänligen försök igen.',
  invalidateCachePrompt: 'Är du säker på att du vill rensa den lokala cachen? Ej synkad information kommmer att försvinna!'
}
